/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { fieldValueMappingRequestSchema } from './fieldValueMappingRequestSchema';

export const saveFieldValueMappingsRequestSchema = z.object({
  get mappings() {
    return z.array(fieldValueMappingRequestSchema);
  },
});
